import { themeQuartz } from 'ag-grid-enterprise';
import { colorSchemeDark } from 'ag-grid-community';
import { jotaiStore } from '~/atoms/authAtom';
import { siteThemeMode } from '~/atoms/userPreferencesAtoms';

// Add global CSS for left-aligned headers and header text wrapping
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    .ag-left-aligned-header .ag-header-cell-label {
      justify-content: flex-start !important;
    }
    /* Prevent word splitting in wrapped header text */
    .ag-header-cell-text {
      word-break: keep-all !important;
      overflow-wrap: normal !important;
      hyphens: none !important;
      white-space: normal !important;
      overflow: visible !important;
      text-overflow: clip !important;
    }
    /* Allow header label to wrap and accommodate sort icon */
    .ag-header-cell-label {
      overflow: visible !important;
      text-overflow: clip !important;
    }
    /* Make sort icon not push text into overflow */
    .ag-sort-indicator-container {
      flex-shrink: 0;
    }
  `;
  if (!document.querySelector('style[data-ag-custom]')) {
    style.setAttribute('data-ag-custom', 'true');
    document.head.appendChild(style);
  }
}
export const createAgTheme = (mode: 'light' | 'dark') => {
  if (mode === 'light') {
    return themeQuartz.withParams({
      accentColor: '#4F9BDA',
      browserColorScheme: 'light',
      fontFamily: {
        googleFont: 'Inter',
      },
      headerFontSize: 14,
      rowHeight: 36,
    });
  }

  return themeQuartz
    .withParams({
      accentColor: '#4F9BDA',
      browserColorScheme: 'dark',
      backgroundColor: '#000000',
      headerBackgroundColor: '#0d0d0d',
      oddRowBackgroundColor: '#0d0d0d',
      rowBackgroundColor: '#1a1a1a',
      foregroundColor: '#e5e5e5',
      borderColor: '#2d2d2d',
      fontFamily: {
        googleFont: 'Inter',
      },
      rowHeight: 36,
    })
    .withPart(colorSchemeDark);
};

const colorSchemeMode = jotaiStore.get(siteThemeMode);
export const agTheme = createAgTheme(colorSchemeMode);
